import React from 'react';
import { ClearableError } from './shared';
import { ErrorMessage } from '../basic/ErrorMessage';

interface ErrorBoundaryPoliteProps {
  errorThresholdMs?: number;
}

interface ErrorBoundaryPoliteState {
  error: ClearableError;
  lastError: ClearableError;
  errorAt: number;
  lastErrorAt: number;
}

/**
 * ErrorBoundaryPolite tries to be non-intrusive by showing a small toast instead of a full
 * error page.
 */
export class ErrorBoundaryPolite extends React.Component<
  ErrorBoundaryPoliteProps,
  ErrorBoundaryPoliteState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      error: null,
      lastError: null,
      errorAt: Date.now(),
      lastErrorAt: Date.now()
    };
  }

  static getDerivedStateFromError(error: Error) {
    return { error, errorAt: Date.now() };
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    const errToast = (
      <ErrorMessage
        key="error-message"
        onDismiss={() => {
          this.setState(old => {
            return {
              ...old,
              error: null
            };
          });
        }}
        errorMessage={error?.message || 'Something went wrong'}
        isShown={!!error}
      />
    );

    return (
      <>
        {errToast}
        {children}
      </>
    );
  }
}
